export default __webpack_public_path__ + "static/media/stand_3.fd57cbac.jpg";